import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth, FullScreenLoader } from "../../context/AuthContext";
import { errorText } from "../../lib/api";
import { LogoMark } from "../../components/Logo";
import { Field, inputCls } from "../../components/admin/Field";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user === null) return <FullScreenLoader />;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B192C] px-5 font-body">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm rounded-3xl bg-white p-7 md:p-9">
        <LogoMark className="h-11 w-11" />
        <h1 className="mt-6 font-display text-3xl text-[#0B192C]">Pitch editor</h1>
        <p className="mt-1 text-sm text-slate-600">Admin access only.</p>
        <div className="mt-7 space-y-4">
          <Field label="Email">
            <input data-testid="admin-login-email" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
          </Field>
          <Field label="Password">
            <input data-testid="admin-login-password" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
          </Field>
        </div>
        {error ? <p data-testid="admin-login-error" className="mt-4 rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700">{error}</p> : null}
        <button data-testid="admin-login-submit" disabled={busy} className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-[#C87D55] py-3.5 font-semibold text-[#0B192C] transition-colors duration-200 hover:bg-[#D4A373] disabled:opacity-60">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null} Log in
        </button>
      </form>
    </div>
  );
}
